import "core-js/modules/es.array.includes";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.includes";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/guoshengli/Documents/vue/kexin-qiye/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sortable from 'sortablejs';
export default {
  props: {
    pagination: {
      type: Object,
      default: function _default() {
        return {
          current: 1,
          total: 0,
          size: 20
        };
      }
    },
    customerNoData: {
      type: Boolean,
      default: true
    },
    observerDomId: {
      // 某个dom高度变化会引起table高度变化，非必传（例如，搜索区域的展开收起）
      type: String,
      default: ''
    },
    scrollable: {
      // table是否需要有滚动条
      type: Boolean,
      default: false
    },
    draggleable: {
      // table是否需要有滚动条
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      tableId: "tableList".concat(new Date().getTime()),
      pageSize: [20, 50, 100, 200],
      maxHeight: 'auto',
      observer: null,
      isDialogFlag: false,
      documentHeight: 0,
      tableTop: 0,
      othersDistance: 0,
      sortable: null,
      tableHasScrollFlag: false // table是否有横向滚动条

    };
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.pageSize.includes(this.pagination.size)) {
      this.pagination.size = 20;
    }

    if (typeof this.$attrs['show-summary'] !== 'undefined') {
      this.tableHasScroll();
    }

    this.$nextTick( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var targetNode, MutationObserver, config;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.scrollable) {
                _context.next = 8;
                break;
              }

              _context.next = 3;
              return _this.getOthersDistance();

            case 3:
              _this.othersDistance = _context.sent;

              _this.getTableHeight(); // 选择需要观察变动的节点


              targetNode = document.getElementById(_this.observerDomId);

              if (targetNode) {
                MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver; // 观察器的配置（需要观察什么变动）

                config = {
                  attributes: true,
                  subtree: true
                }; // 创建一个观察器实例并传入回调函数，当观察到变动时执行的回调函数

                _this.observer = new MutationObserver(function (mutationsList, observer) {
                  _this.getTableHeight();
                }); // 以上述配置开始观察目标节点

                _this.observer.observe(targetNode, config);
              }

              window.addEventListener('resize', _this.getTableHeight);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    if (this.draggleable) {
      this.setSort();
    }

    if (typeof this.$attrs['show-summary'] !== 'undefined') {
      window.addEventListener('resize', this.tableHasScroll);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.scrollable) {
      // 之后，可停止观察
      this.observer && this.observer.disconnect();
      window.removeEventListener('resize', this.getTableHeight);
    }

    if (typeof this.$attrs['show-summary'] !== 'undefined') {
      window.removeEventListener('resize', this.tableHasScroll);
    }
  },
  methods: {
    clearSelection: function clearSelection() {
      this.$refs.multipleTable.clearSelection();
    },
    toggleRowSelection: function toggleRowSelection(val) {
      this.$refs.multipleTable.toggleRowSelection(val);
    },
    // 处理分页
    handleSizeChange: function handleSizeChange(val) {
      this.$emit('pagination-size-change', val);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.$emit('pagination-current-change', val);
    },
    hasScrollbar: function hasScrollbar() {
      return document.body.scrollWidth > (window.innerWidth || document.documentElement.clientWidth);
    },
    getDialog: function getDialog() {
      var dialogDoms = document.getElementsByClassName('el-dialog');
      var targetDom = null;
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          for (var i = 0; i < dialogDoms.length; i++) {
            if (dialogDoms[i].parentNode.style.display !== 'none') {
              targetDom = dialogDoms[i];
              break;
            }
          }

          resolve(targetDom);
        }, 400);
      });
    },
    getTableHeight: function getTableHeight() {
      this.documentHeight = document.documentElement.clientHeight || document.body.clientHeight;
      this.tableTop = document.getElementById(this.tableId) && document.getElementById(this.tableId).getBoundingClientRect().top;
      this.maxHeight = this.documentHeight - this.othersDistance - this.tableTop;
    },
    getOthersDistance: function getOthersDistance() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var pageH, pageDom, scrollbarWidth, dialogDistance, dialogDom;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // 分页高度
                pageH = 0;
                pageDom = document.getElementById('pagination');

                if (pageDom) {
                  pageH = pageDom.getBoundingClientRect().height;
                } // 是否有滚动条


                scrollbarWidth = 0;

                if (_this2.hasScrollbar()) {
                  scrollbarWidth = 8;
                }
                /**
                 * 弹窗中减去的距离的距离
                 */


                dialogDistance = 0;
                _context2.next = 8;
                return _this2.getDialog();

              case 8:
                dialogDom = _context2.sent;
                _this2.isDialogFlag = dialogDom !== null;

                if (_this2.isDialogFlag) {
                  dialogDistance = parseInt(window.getComputedStyle(dialogDom.childNodes[1], null).getPropertyValue('padding-bottom')) + dialogDom.childNodes[2].getBoundingClientRect().height;
                }

                return _context2.abrupt("return", 24 + scrollbarWidth + pageH + dialogDistance);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    tableHasScroll: function tableHasScroll() {
      this.tableHasScrollFlag = document.getElementById(this.tableId).querySelectorAll('.el-table__body-wrapper > table')[0].getBoundingClientRect().width - document.getElementById(this.tableId).querySelectorAll('.el-table__body-wrapper')[0].getBoundingClientRect().width > 1;
    },
    setSort: function setSort() {
      var _this3 = this;

      var el = document.getElementById(this.tableId).querySelectorAll('.el-table__body-wrapper > table > tbody')[0];
      this.sortable = Sortable.create(el, {
        ghostClass: 'drag-handler',
        // Class name for the drop placeholder,
        setData: function setData(dataTransfer) {
          // to avoid Firefox bug
          // Detail see : https://github.com/RubaXa/Sortable/issues/1012
          dataTransfer.setData('Text', '');
        },
        onEnd: function onEnd(evt) {
          // 父组件可这样处理数据
          // const targetRow = this.list.splice(evt.oldIndex, 1)[0]
          // this.list.splice(evt.newIndex, 0, targetRow)
          _this3.$emit('draggleEnd', evt);
        }
      });
    }
  }
};